import React, { FC, useState } from 'react'
import DisableContextMenu from 'components/DisableContextMenu'
import VisibilityTrigger from 'components/VisibilityTrigger'
import Breadcrumb from 'components/SA/Breadcrumb'
import { slugify } from 'lib/slugify'
import { capitalizeString } from 'lib/helpers'

import RelatedSearches from '../components/RelatedSearches'
import { MainContent } from '../components/styles/layout'
import ArtworkDescriptionSection from '../components/ArtworkDescriptionSection'
import AboutArtist from '../components/AboutArtist'
import USPSection from '../components/USPSection'
import LayoutConnector, { ConnectorProps as LayoutProps } from '../connectors/Layout'
import Admin from './Admin'
import Carousels from './Carousels'
import Products from './Products'
import Gallery from '../components/Gallery'
import { getLinkCategory } from "apps/saatchi/artdetail2/helpers";

const PDPLayoutComponent: FC<LayoutProps> = (props) => {
  const { pageIsReady, artistName, artistUserId, category, currentTab } = props
  const [shouldLoadComponent, setShouldLoadComponent] = useState(false)

  const baseLink = `/${slugify(getLinkCategory(category) || 'all')}`
  const medium =
    currentTab !== 'original' && currentTab !== 'info' ? 'Prints' : getLinkCategory(category)
  const mediumLink = currentTab !== 'original' ? '/prints' : baseLink
  const capitalizedArtistName = capitalizeString(artistName)

  return (
    <>
      {pageIsReady && (
        <DisableContextMenu>
          <div style={{ marginTop: '20px' }}>
            <Breadcrumb
              items={[
                {
                  name: 'All Artworks',
                  title: 'See all artworks',
                  url: '/all',
                },
                {
                  name: medium,
                  title: 'See more artworks',
                  url: mediumLink,
                },
                {
                  name: `${capitalizedArtistName} Works`,
                  title: `See more Artworks by ${capitalizedArtistName}`,
                  url: `/account/artworks/${artistUserId}`,
                }
              ]}
            />
          </div>

          <MainContent>
            <Gallery />

            <Products />
          </MainContent>

          <Admin />

          <ArtworkDescriptionSection />

          <VisibilityTrigger setShouldLoadComponent={setShouldLoadComponent} />

          <AboutArtist />

          <Carousels
            shouldLoadComponent={shouldLoadComponent}
            setShouldLoadComponent={setShouldLoadComponent}
          />

          <USPSection />

          {/* <TrustPilotWidget styles={`${'max-width: 1256px;
        margin: 0 auto; padding: 45px 0;'}`} /> */}
          <RelatedSearches />
        </DisableContextMenu>
      )}
    </>
  )
}
export default LayoutConnector(PDPLayoutComponent)
